import React from 'react';

function GreenText(props) {
    return (
        <div className='font_color font_md'>
            <p>{props.title}</p>
        </div>
    );
}

export default GreenText;